export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/ob-step-14.png?a4a197bd095f9656bb5d3a3e34e9d2fb";